// extracted by mini-css-extract-plugin
export var container = "style-module--container--11ed3";
export var get = "style-module--get--e9a1d";
export var info = "style-module--info--54644";
export var screen1 = "style-module--screen1--99744";
export var type = "style-module--type--d6e8d";